import React from 'react'
import PropTypes from 'prop-types'
import ReactExport from 'react-export-excel-xlsx-fix'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import DownloadButton from './DownloadButton'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

export default function MultiSheetCreator({
  label,
  sheets,
  filename,
  icon,
  data,
  pageNames,
  variant,
}) {
  return (
    <ExcelFile
      filename={filename}
      fileExtension="xlsx"
      file
      element={
        <DownloadButton
          variant={variant}
          icon={icon || faDownload}
          label={label || 'Descargar reporte'}
        />
      }
    >
      {sheets.length > 0 &&
        sheets.map((item, index) => (
          <ExcelSheet key={item} data={data[index]} name={pageNames[index]}>
            {item.length > 0 &&
              item.map((element) => (
                <ExcelColumn
                  key={element}
                  label={element.label}
                  value={element.value}
                />
              ))}
          </ExcelSheet>
        ))}
    </ExcelFile>
  )
}

MultiSheetCreator.propTypes = {
  data: PropTypes.array,
  filename: PropTypes.string,
  icon: PropTypes.any,
  label: PropTypes.string,
  pageNames: PropTypes.arrayOf(PropTypes.string),
  sheets: PropTypes.array,
  variant: PropTypes.string,
}
